module.exports = __webpack_public_path__ + "static/proprioceptive_a-5a510020766e727e29ca8d4749500e99.png";